import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { STATE_CULTURE } from "../../common/state";
import Landing from "../../components/Landing";
import PageLayout from "../../components/Styles/PageLayout";
import PageContent from "../../components/Styles/PageContent";
import Description from "../../components/common/Description";
import SiteHeading from "../../components/common/SiteHeading";

let source;

const LandingPage = () => {
  const [text, setText] = useState("");
  const { config, language, culture } = useSelector((state) => ({
    config: state.config,
    language: state.language,
    culture: state.cookies[STATE_CULTURE],
  }));
  const fileName = `landingpage.${culture}.md`;
  useEffect(() => {
    source = axios.CancelToken.source();

    axios
      .get(`${config.baseUrl}/${config.descriptionFolderUrl}${fileName}`, {
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        cancelToken: source.token,
      })
      .then((res) => setText(res.data));
    return () => source.cancel("Component Is Unmounting");
  }, [culture, config.descriptionFolderUrl]);

  useEffect(() => {
    if (config && language) {
      document.title = `${language?.Home} - ${config.shopName}`;
    }
  }, [config, language]);

  return (
    <>
      {config.showSiteHeadingOnlyOnLanding && <SiteHeading />}
      <div className="landing">
        <PageLayout>
          <PageContent>
            <Description text={text} fileName={fileName} />
            {config.landingPage && <Landing />}
          </PageContent>
        </PageLayout>
      </div>
    </>
  );
};

export default LandingPage;
